<template>
    <div class="shipping-form container">
        <div class="columns">
            <div class="column half">
                <form-text label="First name"
                           id="first_name"
                           name="first_name"
                           v-input-sync:first_name="shipping"
                ></form-text>
            </div>
            <div class="column half">
                <form-text label="Last name"
                           id="last_name"
                           name="last_name"
                           v-input-sync:last_name="shipping"
                ></form-text>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <form-text label="Email"
                           type="email"
                           id="email"
                           name="email"
                           v-input-sync:email="shipping"
                ></form-text>
                <form-text label="Phone (optional)"
                           type="tel"
                           id="phone"
                           name="phone"
                           mask="(###) ###-####"
                           :save-mask="false"
                           v-input-sync:phone="shipping"
                ></form-text>
                <form-text label="Street Address"
                           id="address1"
                           name="address1"
                           v-input-sync:address1="shipping"
                ></form-text>
                <form-text label="Address Line 2"
                           id="address2"
                           name="address2"
                           v-input-sync:address2="shipping"
                ></form-text>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <form-text label="City"
                           id="city"
                           name="city"
                           v-input-sync:city="shipping"
                ></form-text>
            </div>
            <div class="column">
                <form-select label="State"
                             id="state"
                             name="state"
                             v-input-sync:state="shipping"
                             :options="states"
                ></form-select>
            </div>
            <div class="column">
                <form-text label="Zip"
                           id="zip"
                           name="zip"
                           mask="#####-####"
                           v-input-sync:zip="shipping"
                ></form-text>
            </div>
        </div>
        <div class="has-text-centered">
            <button class="button btn-sm btn-success" @click="submit()">
                Save
            </button>
        </div>
    </div>
</template>

<script>
    import states from "../utils/us-states"
    import {Form} from "vuex-forms"
    import {required, email, minLength} from "vuex-forms/lib/validators"
    import * as types from "../store/types"
    export default {
        name: 'ShippingForm',
        data() {
            return {
                states: states,
                shipping: new Form(this, this.$store.state.cart.shipping.address, {
                    vuexAction: types.SET_SHIPPING_ADDRESS,
                    validations: {
                        first_name: {required},
                        last_name: {required},
                        email: {required, email},
                        address1: {required},
                        city: {required},
                        state: {required},
                        zip: {required, minLength: minLength(5)},
                    }
                })
            }
        },
        methods: {
            submit() {
                this.shipping.submit().then(data => {
                    this.$emit('saved')
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ShippingForm.vue?fdd203fe